import React from 'react';

interface DataTableProps {
  children: React.ReactNode;
}

interface DataTableHeadProps {
  children: React.ReactNode;
}

interface DataTableBodyProps {
  children: React.ReactNode;
}

interface DataTableRowProps {
  children: React.ReactNode;
  onClick?: () => void;
}

interface DataTableCellProps {
  children: React.ReactNode;
  className?: string;
  align?: 'left' | 'center' | 'right';
  variant?: 'default' | 'primary' | 'secondary' | 'date';
}

export const DataTable: React.FC<DataTableProps> = ({ children }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">{children}</table>
    </div>
  );
};

export const DataTableHead: React.FC<DataTableHeadProps> = ({ children }) => {
  return (
    <thead className="bg-gray-50">
      <tr>{children}</tr>
    </thead>
  );
};

export const DataTableBody: React.FC<DataTableBodyProps> = ({ children }) => {
  return <tbody className="bg-white divide-y divide-gray-200">{children}</tbody>;
};

export const DataTableRow: React.FC<DataTableRowProps> = ({ children, onClick }) => {
  return (
    <tr className={`hover:bg-gray-50 ${onClick ? 'cursor-pointer' : ''}`} onClick={onClick}>
      {children}
    </tr>
  );
};

export const DataTableCell: React.FC<DataTableCellProps> = ({
  children,
  className = '',
  align = 'left',
  variant = 'default',
}) => {
  const alignClass = align === 'center' ? 'text-center' : align === 'right' ? 'text-right' : 'text-left';

  const variantClasses = {
    default: 'px-4 py-4',
    primary: 'px-4 py-4 text-sm font-medium text-gray-900',
    secondary: 'px-4 py-4 text-sm text-gray-500',
    date: 'px-4 py-4 whitespace-nowrap text-sm text-gray-500',
  };

  return (
    <td className={`${variantClasses[variant]} ${alignClass} ${className}`}>
      {align === 'center' ? <div className="flex justify-center">{children}</div> : children}
    </td>
  );
};
